export const clientTheme = {
    mainLayout: {
        backgroundColor: '#fafaf9',
        hover: {
            backgroundColor: '#3BCFF0',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#1B1B6F',
        userIcon: '#FF1F3E',
        brandLogo: {
            maxWidth: '160px',
            paddingTop: '',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#333436',
        darkBackgroundColor: '#1f2024',
        sideMenuActive: {
            backgroundColor: '#FF1F3E',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#FF1F3E',
        stroke: '#FF1F3E',
        lineCharts: {
            stroke: '#FF1F3E',
            fill: '#FF1F3E',
        },
        areaCharts: {
            gradient: {
                start: '#FF1F3E',
                stop: '#FF1F3E',
            },
            stroke: '#FF1F3E',
            fill: '#FF1F3E',
            newAlertsByDateChart: [
                {
                    stroke: '#000000',
                    fill: 'rgba(0, 0, 0, 0.5)',
                },
                {
                    stroke: '#1B1B6F',
                    fill: 'rgba(27, 27, 111, 0.5)',
                },
                {
                    stroke: '#FF1F3E',
                    fill: 'rgba(255, 31, 62, 0.5)',
                },
                {
                    stroke: '#3BCFF0',
                    fill: 'rgba(59, 207, 240, 0.5)',
                },
                {
                    stroke: '#4C12A1',
                    fill: 'rgba(76, 18, 161, 0.5)',
                },
                {
                    stroke: '#A18CDE',
                    fill: 'rgba(161, 140, 222, 0.5)',
                },
                {
                    stroke: '#FD65BC',
                    fill: 'rgba(253, 101, 188, 0.5)',
                },
            ],
        },
        barCharts: {
            fill: '#FF1F3E',
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: 'rgb(54, 119, 176)',
                lineColor: '#cb2022',
            },
        },
        pieCharts: {
            defaultPieChart: [
                '#1B1B6F',
                '#FF1F3E',
                '#3BCFF0',
                '#4C12A1',
                '#A18CDE',
            ],
        },
        radialBarCharts: {
            fill: '#1B1B6F',
        },
    },
    lockAndUnlockButton: {
        lockButton: {
            backgroundColor: '#FF1F3E',
            '&:hover': {
                backgroundColor: '#E61C38',
            },
        },
        unlockButton: {
            backgroundColor: '#3BCFF0',
            '&:hover': {
                backgroundColor: '#35BBD9',
            },
        },
    },
    lampColors: {
        green: '#3BCFF0',
        red: '#FF1F3E',
        orange: '#FD65BC',
        yellow: '#A18CDE',
        grey: '#CCCCCC',
    },
    uploadDnD: {
        borderColor: `#FF1F3E`,
        backgroundColor: `rgba(255, 31, 62, 0.1)`,
        labelColor: `#FF1F3E`,
    },
    metricTile: {
        arrow: {
            width: 26,
            height: 40,
        },
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '#FF1F3E',
        borderRadius: '3px',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#333',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e0e0e0',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#1B1B6F',
                '&:hover': {
                    backgroundColor: '#151559',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid rgba(0, 0, 0, 0.23) !important',
                borderRadius: '4px !important',
                color: '#263238',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#4f4f4f',
                backgroundColor: '#D5D5D5',
                '&:hover': {
                    color: '#4f4f4f',
                    backgroundColor: '#D5D5D5',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#3BCFF0',
                '&:hover': {
                    backgroundColor: '#35BBD9',
                },
            },
        },
        activeStateButton: {
            color: 'white',
            backgroundColor: '#61656E',
        },
        redButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#FF1F3E',
                '&:hover': {
                    backgroundColor: '#FF1F3E',
                },
            },
        },
    },
    icons: {
        uploadIcon: '#3BCFF0',
        dnrAndRevertDnrIcon: '#FF1F3E',
        toggleUnlockIcon: '#CCCCCC',
        toggleLockIcon: '#FF1F3E',
        editUserIcon: '#1B1B6F',
        midPermissionIcon: '#4C12A1',
        sitePermissionIcon: '#FD65BC',
        tempPasswordIcon: '#3BCFF0',
    },
    main: '#FF1F3E',
    primaryLight: '#FF1F3E',
    primary: '#FF1F3E',
    primaryDark: '#E61C38',
    secondaryLight: '#3BCFF0',
    secondary: '#1B1B6F',
    secondaryDark: '#1B1B6F',
    hyperlink: '#1B1B6F',
    textField: '#000000',
    switch: '#FF1F3E',
    typography: {
        fontColor: {
            primaryText: '#333',
            secondaryText: '#333',
        },
        fontFamily: ['Blinker'],
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#333333',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
}

export const iconsTheme = {
    home: 'icon-home',
    code: 'icon-code',
    moneyCheckAlt: 'icon-money-check-alt',
    exclamationCircle: 'icon-exclamation-circle',
    chartPie: 'icon-chart',
    users: 'icon-users',
    cog: 'icon-cog',
    lifeRing: 'icon-life-ring',
    creditCard: 'icon-credit-card',
    calendar: 'icon-calendar',
    briefcase: 'icon-briefcase',
    singleConsumer: 'icon-consumer-single',
    singleConsumerStyle: 'icon-consumer-single-style',
    notification: 'icon-notification',
    clock: 'icon-clock',
    star: 'icon-star',
    clipboard: 'icon-clipboard',
    cogs: 'icon-cogs',
    check: 'icon-check',
    ban: 'icon-ban',
    clockTwo: 'icon-clock-o',
    question: 'icon-question',
    bell: 'icon-bell',
    exchange: 'fas fa-exchange',
    outdentBar: '',
    indentBar: '',
    bars: 'icon-bars',
    document: 'icon-document',
    toggleUnlock: 'icon-toggle-unlock',
    toggleLock: 'icon-toggle-lock',
    edit: 'icon-edit',
    midPermission: 'icon-mid-permission',
    sitePermission: 'icon-site-permission',
    tempPassword: 'icon-temp-password',
    trashCan: 'icon-trash-can',
    wheel: 'icon-wheel',
    flagged: 'icon-flagged',
    unflagged: 'icon-unflagged',
    assign: 'icon-assign',
    cross: 'icon-cross',
    inProgress: '',
    win: '',
    loss: '',
    upload: '',
    solidLock: 'fas fa-lock',
    download: 'fas fa-download',
}
